import { useQuery } from '@apollo/client';
import nonEmpty from '../utils/nonEmpty';
import { gql } from '../graphql/generated/gql';

const EXTERNAL_POSTS_QUERY = gql(`
  query externalPostPlatforms {
    platforms: externalPostPlatforms {
      id
    }
  }
`);

const useExternalPostPlatforms = () => {
  const { data } = useQuery(EXTERNAL_POSTS_QUERY);

  return data?.platforms?.filter(nonEmpty) ?? [];
};

export default useExternalPostPlatforms;
